import { Host, h, } from "@stencil/core";
export class GxgOptionsItem {
    constructor() {
        this.disabled = false;
    }
    el;
    keyDown;
    optionSelected;
    keyDownHandler(e) {
        const enter = e.code === "Enter";
        if (enter) {
            //simulate click
            this.el.click();
        }
        else {
            const escape = e.code === "Escape";
            const dataId = e.target.getAttribute("data-id");
            const code = e.code;
            this.keyDown.emit({ direction: code, dataId: dataId, escape: escape });
        }
    }
    clickHandler(e) {
        e.stopPropagation();
        const dataId = e.target.getAttribute("data-id");
        const id = e.target.getAttribute("id");
        if (!this.disabled) {
            this.optionSelected.emit({ dataId: dataId, id: id });
        }
    }
    render() {
        return (h(Host, { class: {
                "options-item": true,
                "options-item--disabled": this.disabled,
            }, tabindex: "0", onKeyDown: this.keyDownHandler.bind(this), onClick: this.clickHandler.bind(this) }, h("div", { class: "options-item__wrapper" }, h("p", { class: "options-item__p" }, h("slot", null)))));
    }
    static get is() { return "gxg-options-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-options-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-options-item.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "keyDown",
                "name": "keyDown",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "optionSelected",
                "name": "optionSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=gxg-options-item.js.map
